import React from 'react';

import {Skeleton, Stack} from 'views/components';

const TaskListSkeleton = () => {
  return (
    <Stack spacing={1.5}>
      <Skeleton variant="rounded" height={36} />
      <Skeleton variant="rounded" height={36} />
    </Stack>
  );
};

export default React.memo(TaskListSkeleton);
